module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('h2', [_c('small', [_vm._v("Panduan Pengguna")])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "start",
      "align": "top"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4,
      "align": "left"
    }
  }, [_c('el-menu', {
    attrs: {
      "unique-opened": true
    },
    on: {
      "select": _vm.onClick
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._l((_vm.contents), function(item, index) {
    return (item.visible && !item.children) ? _c('el-menu-item', {
      key: item.key,
      attrs: {
        "index": '' + index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon ? 'text-warning fa fa-' + item.icon : ''
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.isDesktop || _vm.isTablet ? item.title : ''))])])], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.contents), function(item, index) {
    return (item.visible && item.children) ? _c('el-submenu', {
      key: item.key,
      attrs: {
        "index": '' + index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon ? 'text-warning fa fa-' + item.icon : ''
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _vm._l((item.children), function(sub, ind2) {
      return (sub.visible) ? _c('el-menu-item', {
        key: sub.key,
        attrs: {
          "index": sub.key,
          "disabled": sub.disabled
        }
      }, [_c('i', {
        class: sub.icon ? 'text-muted fa fa-' + sub.icon : ''
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(sub.title))])]) : _vm._e()
    })], 2) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-col', [_c('div', {
    staticClass: "padded"
  }, [_c('pdf-viewer', {
    attrs: {
      "url": _vm.url,
      "show-rotate": false,
      "show-page-numbers-bottom": ""
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b2f4766"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/HelpBahasaMalaysia.vue
// module id = 1672
// module chunks = 0